export default {
  text: '#020303',
  primary: '#e66495',
  secondary: '#a3326a', //#7b0101
  background: '#E66495',
  backgroundSecondary: '#E66495',
  light: '#FFF',
  dark: '#020303'
}
